export default __webpack_public_path__ + "static/media/122.5b00f0bf.svg";